import { AnyAction } from 'redux';
import {
  FamilienstandChanged,
  PlzChanged,
  Produktlinie,
  VermietetesBebautesModalObjektChangedPayload,
  VermietetesModalObjektChangedPayload,
  VermietetesObjekt,
  VermietetesUnbebautesModalObjektChangedPayload,
} from '@ps20-frontend/frontend-models';
import { FamilienStand, Selbstbeteiligung } from '@ps20/bff-models';
import { Injectable } from '@angular/core';
import { TARIF_CHECKED } from '@ps20-frontend/shop-integration-redux';

export interface RsVermietungAction<T = undefined> extends AnyAction {
  payload?: T;
}

@Injectable()
export class RsVermieterActions {
  static readonly FAMILIENSTAND_CHANGED = 'FAMILIENSTAND_CHANGED';
  static readonly SELBSTBETEILIGUNG_CHANGED = 'SELBSTBETEILIGUNG_CHANGED';
  static readonly ZUM_ANGEBOT_BUTTON_CLICKED = 'ZUM_ANGEBOT_BUTTON_CLICKED';
  static readonly ZURUECK_ZUM_SHOP_MODAL_CLOSE = 'ZURUECK_ZUM_SHOP_MODAL_CLOSE';
  static readonly ZURUECK_ZUM_SHOP_MODAL_OPEN = 'ZURUECK_ZUM_SHOP_MODAL_OPEN';
  static readonly ABSPRUNG_INS_DASHBOARD = 'ABSPRUNG_INS_DASHBOARD';
  static readonly PREIS_REQUESTED = 'PREIS_REQUESTED';
  static readonly PRODUKTLINIEN_CHANGED = 'PRODUKTLINIEN_CHANGED';
  static readonly VERMIETETES_CARD_OBJEKT_CHANGED = 'VERMIETETES_CARD_OBJEKT_CHANGED';
  static readonly VERMIETETES_BEBAUTES_CARD_OBJEKT_CHANGED = 'VERMIETETES_BEBAUTES_CARD_OBJEKT_CHANGED';
  static readonly VERMIETETES_UNBEBAUTES_CARD_OBJEKT_CHANGED = 'VERMIETETES_UNBEBAUTES_CARD_OBJEKT_CHANGED';
  static readonly VERMIETETES_CARD_OBJEKT_ADDED = 'VERMIETETES_CARD_OBJEKT_ADDED';
  static readonly VERMIETETES_CARD_OBJEKT_DELETED = 'VERMIETETES_CARD_OBJEKT_DELETED';
  static readonly PLZ_CHANGED = 'PLZ_CHANGED';
  static readonly ANZAHL_RECHTSSTREITIGKEITEN_CHANGED = 'ANZAHL_RECHTSSTREITIGKEITEN_CHANGED';
  static readonly RECHTSSTREITIGKEITEN_CHANGED = 'RECHTSSTREITIGKEITEN_CHANGED';
  static readonly VORSCHLAGDATEN_CHANGED = 'VORSCHLAGDATEN_CHANGED';
  static readonly ANTRAGSNUMMER_GENERATED = 'ANTRAGSNUMMER_GENERATED';
  static readonly REMOVE_VERMIETETES_OBJEKT = 'REMOVE_VERMIETETES_OBJEKT';
  static readonly OVERWRITE_VERMIETETE_OBJEKTE = 'OVERWRITE_VERMIETETE_OBJEKTE';
  static readonly HANDLE_RS_VERMIETUNG_NAVIGATION_TO_ANGEBOT = 'HANDLE_RS_VERMIETUNG_NAVIGATION_TO_ANGEBOT';
  static readonly QUOTEDB_REQUESTED_RS_VERMIETUNG = 'QUOTEDB_REQUESTED_RS_VERMIETUNG';

  zurueckZumShopModalOpen(): RsVermietungAction {
    return { type: RsVermieterActions.ZURUECK_ZUM_SHOP_MODAL_OPEN };
  }

  overwriteVermieteteObjekte(
    vermieteteObjekte: Array<VermietetesObjekt>,
  ): RsVermietungAction<Array<VermietetesObjekt>> {
    return {
      type: RsVermieterActions.OVERWRITE_VERMIETETE_OBJEKTE,
      payload: vermieteteObjekte,
    };
  }

  familienstandChanged(familienstand: FamilienStand): RsVermietungAction<FamilienstandChanged> {
    return {
      type: RsVermieterActions.FAMILIENSTAND_CHANGED,
      payload: { familienstand },
    };
  }

  zumAngebotButtonClicked(): RsVermietungAction {
    return { type: RsVermieterActions.ZUM_ANGEBOT_BUTTON_CLICKED };
  }

  zurueckZumShopModalClose(): RsVermietungAction {
    return { type: RsVermieterActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE };
  }

  tarifChecked(index: number): RsVermietungAction<{ index: number }> {
    return { type: TARIF_CHECKED, payload: { index } };
  }

  absprungInsDashboard(): RsVermietungAction {
    return { type: RsVermieterActions.ABSPRUNG_INS_DASHBOARD };
  }

  selbstbeteiligungChanged(
    selbstbeteiligung: Selbstbeteiligung,
  ): RsVermietungAction<Selbstbeteiligung> {
    return {
      type: RsVermieterActions.SELBSTBETEILIGUNG_CHANGED,
      payload: selbstbeteiligung,
    };
  }

  preisRequested(): RsVermietungAction {
    return { type: RsVermieterActions.PREIS_REQUESTED };
  }

  produktlinienChanged(produktlinien: Produktlinie[]): RsVermietungAction<Produktlinie[]> {
    return { type: RsVermieterActions.PRODUKTLINIEN_CHANGED, payload: produktlinien };
  }

  VermietetesModalObjektChanged(
    changedVermietetesObjekt: VermietetesModalObjektChangedPayload,
  ): RsVermietungAction<VermietetesModalObjektChangedPayload> {
    return {
      type: RsVermieterActions.VERMIETETES_CARD_OBJEKT_CHANGED,
      payload: changedVermietetesObjekt,
    };
  }

  VermietetesBebautesModalObjektChanged(
    changedVermietetesObjekt: VermietetesBebautesModalObjektChangedPayload,
  ): RsVermietungAction<VermietetesBebautesModalObjektChangedPayload> {
    return {
      type: RsVermieterActions.VERMIETETES_BEBAUTES_CARD_OBJEKT_CHANGED,
      payload: changedVermietetesObjekt,
    };
  }

  VermietetesUnbebautesModalObjektChanged(
    changedVermietetesObjekt: VermietetesUnbebautesModalObjektChangedPayload,
  ): RsVermietungAction<VermietetesUnbebautesModalObjektChangedPayload> {
    return {
      type: RsVermieterActions.VERMIETETES_UNBEBAUTES_CARD_OBJEKT_CHANGED,
      payload: changedVermietetesObjekt,
    };
  }

  VermietetesModalObjektAdded(): RsVermietungAction {
    return { type: RsVermieterActions.VERMIETETES_CARD_OBJEKT_ADDED };
  }

  VermietetesModalObjektDeleted(index: number): RsVermietungAction<number> {
    return { type: RsVermieterActions.VERMIETETES_CARD_OBJEKT_DELETED, payload: index };
  }

  plzChanged(plz: string): RsVermietungAction<PlzChanged> {
    return { type: RsVermieterActions.PLZ_CHANGED, payload: { plz } };
  }

  rechtsstreitigkeitenVorhandenChanged(
    rechtsstreitigkeitenVorhanden: boolean,
  ): RsVermietungAction<boolean> {
    return {
      type: RsVermieterActions.RECHTSSTREITIGKEITEN_CHANGED,
      payload: rechtsstreitigkeitenVorhanden,
    };
  }

  anzahlRechtsstreitigkeitenChanged(
    anzahlRechtsstreitigkeiten: number,
  ): RsVermietungAction<number> {
    return {
      type: RsVermieterActions.ANZAHL_RECHTSSTREITIGKEITEN_CHANGED,
      payload: anzahlRechtsstreitigkeiten,
    };
  }

  vorschlagdatenChanged(): AnyAction {
    return { type: RsVermieterActions.VORSCHLAGDATEN_CHANGED };
  }

  antragsnummerGenerated(antragsnummer: string): RsVermietungAction<{ antragsnummer: string }> {
    return {
      type: RsVermieterActions.ANTRAGSNUMMER_GENERATED,
      payload: { antragsnummer },
    };
  }

  removeVermietetesObjekt(id: string): RsVermietungAction<{ id: string }> {
    return { type: RsVermieterActions.REMOVE_VERMIETETES_OBJEKT, payload: { id } };
  }

  handleRsVermietungNavigationToAngebot(): RsVermietungAction {
    return { type: RsVermieterActions.HANDLE_RS_VERMIETUNG_NAVIGATION_TO_ANGEBOT };
  }

  quoteDBRequested(): RsVermietungAction {
    return { type: RsVermieterActions.QUOTEDB_REQUESTED_RS_VERMIETUNG };
  }
}
